<template>
  <div class="home">
    <div class="sideBar">
      <div class="profileBlock">
        <img width="45" src="../assets/logo.svg" />
      </div>
      <div class="components_block">
        <div class="components">
          <div class="component activated" id="home" @click="changeMode">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M3.25 11.9495C3.25 10.2523 3.25 9.40372 3.59308 8.65779C3.93615 7.91187 4.58046 7.35961 5.86906 6.25509L7.11906 5.18366C9.44821 3.18725 10.6128 2.18904 12 2.18904C13.3872 2.18904 14.5518 3.18725 16.8809 5.18366L18.1309 6.25509C19.4195 7.35961 20.0638 7.91187 20.4069 8.65779C20.75 9.40372 20.75 10.2523 20.75 11.9495V17.25C20.75 19.607 20.75 20.7855 20.0178 21.5178C19.2855 22.25 18.107 22.25 15.75 22.25H8.25C5.89298 22.25 4.71447 22.25 3.98223 21.5178C3.25 20.7855 3.25 19.607 3.25 17.25V11.9495Z"
                stroke="#60CB89"
                stroke-width="2"
              />
              <path d="M15.125 22.25V15.75C15.125 15.1977 14.6773 14.75 14.125 14.75H9.875C9.32272 14.75 8.875 15.1977 8.875 15.75V22.25" stroke="#60CB89" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </div>
          <div class="component" id="launch" @click="changeMode">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M12.0186 2.91406L12.1836 2.96387C12.5449 3.10184 12.74 3.39015 12.8301 3.5918C12.9229 3.79962 12.9544 4.01359 12.9697 4.15625C13.0014 4.45121 13 4.85227 13 5.27051V9.2002H13.8701C14.5411 9.2002 15.1589 9.19739 15.6387 9.26855C16.1043 9.33767 16.6659 9.50642 17.0469 10.0166L17.1201 10.123L17.1865 10.2344C17.4895 10.7946 17.4064 11.3755 17.2734 11.8271C17.2049 12.0598 17.1051 12.3158 16.9873 12.5898L16.5928 13.46L13.8613 19.3604C13.6856 19.74 13.5179 20.1041 13.3652 20.3584C13.2913 20.4815 13.1736 20.6629 13.002 20.8125C12.8354 20.9576 12.5371 21.1369 12.1514 21.1104L11.9814 21.0859C11.513 20.9828 11.2729 20.6386 11.1699 20.4082C11.0771 20.2004 11.0456 19.9864 11.0303 19.8438C10.9986 19.5488 11 19.1477 11 18.7295V14.7998H10.1299C9.45893 14.7998 8.84111 14.8026 8.36133 14.7314C7.8957 14.6623 7.3341 14.4936 6.95312 13.9834L6.87988 13.877C6.50039 13.2831 6.58475 12.6545 6.72656 12.1729C6.86352 11.7077 7.12542 11.1487 7.40723 10.54L10.1387 4.63965L10.3955 4.09375C10.4783 3.92341 10.5584 3.76878 10.6348 3.6416C10.7087 3.51853 10.8264 3.33713 10.998 3.1875C11.1646 3.04239 11.4629 2.86306 11.8486 2.88965L12.0186 2.91406Z"
                stroke="#60CB89"
                stroke-width="2"
              />
            </svg>
          </div>
          <div class="component" id="createToken" @click="changeMode">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <circle cx="12" cy="12" r="9" stroke="#60CB89" stroke-width="2" />
              <path d="M12 15L12 9" stroke="#60CB89" stroke-width="2" stroke-linecap="square" />
              <path d="M15 12L9 12" stroke="#60CB89" stroke-width="2" stroke-linecap="square" />
            </svg>
          </div>
          <div class="component" id="tokens" @click="openTokens">
            <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M19 3V3C19.1857 3 19.2786 3 19.3569 3.00685C20.2271 3.08298 20.917 3.77292 20.9932 4.64312C21 4.72141 21 4.81427 21 5V16.12C21 17.1281 21 17.6321 20.8038 18.0172C20.6312 18.3559 20.3559 18.6312 20.0172 18.8038C19.6321 19 19.1281 19 18.12 19H5.88C4.87191 19 4.36786 19 3.98282 18.8038C3.64413 18.6312 3.36876 18.3559 3.19619 18.0172C3 17.6321 3 17.1281 3 16.12V5C3 4.81427 3 4.72141 3.00685 4.64312C3.08298 3.77292 3.77292 3.08298 4.64312 3.00685C4.72141 3 4.81427 3 5 3V3"
                stroke="#60CB89"
                stroke-width="2"
              />
              <path
                d="M19 3H18.118C17.6329 3 17.3903 3 17.185 3.09862C17.1214 3.12917 17.0612 3.16636 17.0055 3.20958C16.8255 3.34909 16.717 3.56606 16.5 4V4C16.283 4.43394 16.1745 4.65091 15.9945 4.79042C15.9388 4.83364 15.8786 4.87083 15.815 4.90138C15.6097 5 15.3671 5 14.882 5H8.91667C8.51499 5 8.31415 5 8.14071 4.93323C8.00297 4.8802 7.87867 4.79733 7.77675 4.69058C7.6484 4.55617 7.57116 4.37078 7.41667 4V4C7.26218 3.62922 7.18493 3.44383 7.05659 3.30942C6.95466 3.20267 6.83036 3.1198 6.69262 3.06677C6.51918 3 6.31834 3 5.91667 3H5"
                stroke="#60CB89"
                stroke-width="2"
              />
              <path
                d="M21 8H18.118C17.6329 8 17.3903 8 17.185 8.09862C17.1214 8.12917 17.0612 8.16636 17.0055 8.20958C16.8255 8.34909 16.717 8.56606 16.5 9V9C16.283 9.43394 16.1745 9.65091 15.9945 9.79042C15.9388 9.83364 15.8786 9.87083 15.815 9.90138C15.6097 10 15.3671 10 14.882 10H8.91667C8.51499 10 8.31415 10 8.14071 9.93323C8.00297 9.8802 7.87867 9.79733 7.77675 9.69058C7.6484 9.55617 7.57116 9.37078 7.41667 9V9C7.26218 8.62922 7.18493 8.44383 7.05659 8.30942C6.95466 8.20267 6.83036 8.1198 6.69262 8.06677C6.51918 8 6.31834 8 5.91667 8H3"
                stroke="#60CB89"
                stroke-width="2"
              />
              <path
                d="M21 13H18.118C17.6329 13 17.3903 13 17.185 13.0986C17.1214 13.1292 17.0612 13.1664 17.0055 13.2096C16.8255 13.3491 16.717 13.5661 16.5 14V14C16.283 14.4339 16.1745 14.6509 15.9945 14.7904C15.9388 14.8336 15.8786 14.8708 15.815 14.9014C15.6097 15 15.3671 15 14.882 15H8.91667C8.51499 15 8.31415 15 8.14071 14.9332C8.00297 14.8802 7.87867 14.7973 7.77675 14.6906C7.6484 14.5562 7.57116 14.3708 7.41667 14V14C7.26218 13.6292 7.18493 13.4438 7.05659 13.3094C6.95466 13.2027 6.83036 13.1198 6.69262 13.0668C6.51918 13 6.31834 13 5.91667 13H3"
                stroke="#60CB89"
                stroke-width="2"
              />
            </svg>
          </div>
          <div class="component" id="payers" @click="changeMode">
            <svg width="24" height="22" viewBox="0 0 24 22" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M14.25 3H9.75C6.56802 3 4.97703 3 3.98851 4.00421C3 5.00841 3 6.62465 3 9.85714V12.1429C3 15.3753 3 16.9916 3.98851 17.9958C4.97703 19 6.56802 19 9.75 19H14.25C17.432 19 19.023 19 20.0115 17.9958C21 16.9916 21 15.3753 21 12.1429V9.85714C21 6.62465 21 5.00841 20.0115 4.00421C19.023 3 17.432 3 14.25 3Z"
                stroke="#60CB89"
                stroke-width="2"
              />
              <path d="M7 7H10" stroke="#60CB89" stroke-width="2" stroke-linecap="round" />
              <path
                d="M19 15H17C16.0572 15 15.5858 15 15.2929 14.7071C15 14.4142 15 13.9428 15 13C15 12.0572 15 11.5858 15.2929 11.2929C15.5858 11 16.0572 11 17 11H19C19.9428 11 20.4142 11 20.7071 11.2929C21 11.5858 21 12.0572 21 13C21 13.9428 21 14.4142 20.7071 14.7071C20.4142 15 19.9428 15 19 15Z"
                stroke="#60CB89"
                stroke-width="2"
              />
            </svg>
          </div>
          <div class="component" id="eyes" @click="changeMode">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2.5 12C4.5 7.5 8.05 5 12 5C15.95 5 19.5 7.5 21.5 12C19.5 16.5 15.95 19 12 19C8.05 19 4.5 16.5 2.5 12Z" stroke="#60CB89" stroke-width="2" />
              <circle cx="12" cy="12" r="2.5" stroke="#60CB89" stroke-width="2" />
            </svg>
          </div>
          <div class="component" id="settings" @click="changeMode">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <rect x="18" y="9" width="4" height="4" rx="2" transform="rotate(90 18 9)" stroke="#60CB89" stroke-width="2" />
              <rect x="18" y="17" width="4" height="4" rx="2" transform="rotate(90 18 17)" stroke="#60CB89" stroke-width="2" />
              <rect x="3" y="7" width="4" height="4" rx="2" transform="rotate(-90 3 7)" stroke="#60CB89" stroke-width="2" />
              <path d="M5 8V15C5 16.8856 5 17.8284 5.58579 18.4142C6.17157 19 7.11438 19 9 19H14" stroke="#60CB89" stroke-width="2" />
              <path d="M5 7V7C5 8.88562 5 9.82843 5.58579 10.4142C6.17157 11 7.11438 11 9 11H14" stroke="#60CB89" stroke-width="2" />
            </svg>
          </div>
        </div>
        <div class="component" @click="exitProfile">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M2 12L1.21913 11.3753L0.719375 12L1.21913 12.6247L2 12ZM11 13C11.5523 13 12 12.5523 12 12C12 11.4477 11.5523 11 11 11V13ZM6 7L5.21913 6.3753L1.21913 11.3753L2 12L2.78087 12.6247L6.78087 7.6247L6 7ZM2 12L1.21913 12.6247L5.21913 17.6247L6 17L6.78087 16.3753L2.78087 11.3753L2 12ZM2 12V13H11V12V11H2V12Z"
              fill="#60CB89"
            />
            <path
              d="M10 8.13193V7.38851C10 5.77017 10 4.961 10.474 4.4015C10.9479 3.84201 11.7461 3.70899 13.3424 3.44293L15.0136 3.1644C18.2567 2.62388 19.8782 2.35363 20.9391 3.25232C22 4.15102 22 5.79493 22 9.08276V14.9172C22 18.2051 22 19.849 20.9391 20.7477C19.8782 21.6464 18.2567 21.3761 15.0136 20.8356L13.3424 20.5571C11.7461 20.291 10.9479 20.158 10.474 19.5985C10 19.039 10 18.2298 10 16.6115V16.066"
              stroke="#60CB89"
              stroke-width="2"
            />
          </svg>
        </div>
      </div>
    </div>
    <div class="workBlock">
      <Transition name="fade">
        <component :is="currentComponent" class="workComponent" />
        <!-- <ProjectComponent v-if="mode == 'home'"/>
        <LaunchComponent v-if="mode == 'launch'"/> -->
      </Transition>
    </div>
  </div>
</template>

<script>
import CreateToken from "@/components/CreateToken.vue";
import EyesComponent from "@/components/EyesComponent.vue";
import LaunchComponent from "@/components/LaunchComponent.vue";
import PayersComponent from "@/components/PayersComponent.vue";
import ProjectComponent from "@/components/ProjectComponent.vue";
import SettingsComponent from "@/components/SettingsComponent.vue";
import TransactionsComponent from "@/components/TransactionsComponent.vue";
import axios from "axios";
import { computed, ref } from "vue";

// @ is an alias to /src
export default {
  name: "HomeView",
  data() {
    return {
      user: this.$store.getters.getUserData,
      tokens: [],
      isTokens: false,
    };
  },
  setup() {
    const expandedNames = ref([]); // По умолчанию закрыто

    const toggleCollapse = () => {
      expandedNames.value = expandedNames.value.includes("1") ? [] : ["1"];
    };

    const mode = ref("home");
    const currentComponent = computed(() => {
      return mode.value === "home"
        ? ProjectComponent
        : mode.value === "launch"
        ? LaunchComponent
        : mode.value === "createToken"
        ? CreateToken
        : mode.value === "transactions"
        ? TransactionsComponent
        : mode.value === "payers"
        ? PayersComponent
        : mode.value === "eyes"
        ? EyesComponent
        : mode.value === "settings"
        ? SettingsComponent
        : null;
    });
    return {
      expandedNames,
      toggleCollapse,
      mode,
      currentComponent,
    };
  },
  methods: {
    openTokens() {
      this.isTokens = true;
      for (let i = 0; i < this.tokens.length; i++) {
        this.loadImage(i);
      }
    },
    changeMode(event) {
      let el = event.target.closest(".component");
      this.mode = el.id;
      let els = document.querySelectorAll(".component");
      for (let e of els) e.className = "component";
      el.classList.add("activated");
    },
    getTokens() {
      axios
        .get(`${process.env.VUE_APP_SERVERHOST}/api/token/my`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.getUserData.key}`,
          },
        })
        .then((res) => {
          this.tokens = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    loadImage(i) {
      axios.get(this.tokens[i].imageUrl).then((res) => {
        this.tokens[i].image = res.data.image;
      });
    },
    exitProfile() {
      this.$store.commit("setUser", null);
      window.location.href = "/";
    },
  },

  mounted() {
    console.log("USER", this.$store.getters.getTokens);
    this.getTokens();
  },
  components: {
    ProjectComponent,
    LaunchComponent,
    CreateToken,
    EyesComponent,
  },
};
</script>

<style scoped>
.home {
  width: 100vw;
  height: 100vh;
  display: flex;
}
.sideBar {
  width: fit-content;
  height: 100vh;
  background-color: #171717;
  display: flex;
  flex-direction: column;
  padding: 15px;
}
.profileBlock {
  margin-top: 3vh;
}
.components {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  gap: 3vh;
  margin-top: 5vh;
}
.components_block {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.component {
  display: flex;
  align-items: center;
  font-size: 16px;
  transition: 0.3s all;
  cursor: pointer;
  user-select: none;
  border: 1px solid #60cb89;
  border-radius: 10px;
  transition: all 0.3s;
  width: fit-content;
  margin: 0 auto;
  padding: 10px;
}
.component:hover {
  background: #60cb89;
}
.component:hover svg path,
.component.activated svg path {
  stroke: white;
}
.component:hover svg rect,
.component.activated svg rect {
  stroke: white;
}
.component:hover svg circle,
.component.activated svg circle {
  stroke: white;
}
.component.activated {
  background: #60cb89;
}
.component svg {
  width: 1.5rem;
  height: 1.5rem;
}
.workBlock {
  display: flex;
  width: 100%;
  position: relative;
  overflow: auto;
}
.workComponent {
  position: absolute;
  width: 100%;
}
:deep(.n-base-icon svg path) {
  fill: white;
}
:deep(.n-base-icon svg) {
  width: 20px;
}
:deep(.n-card__content) {
  display: flex !important;
  gap: 10px;
  overflow-y: auto;
  padding-bottom: 10px;
}
</style>
